<script lang="ts" setup>
/**
 * Google OAuth登录URL
 * 使用环境变量中的API URL，或默认为本地开发环境URL
 * 需要在.env文件中设置VITE_API_URL
 */
// const GOOGLE_AUTH_URL = isTest?
//   ? `${import.meta.env.VITE_API_URL}/api/auth/google`
//   : 'http://localhost:3000/api/auth/google'
//
// /**
//  * 在存储中保存当前URL作为登录后重定向目标
//  * 这样用户在登录后将回到他们原来的页面
//  */
// function saveRedirectUrl() {
//   // 保存当前路径作为登录成功后的重定向地址
//   const currentPath = window.location.pathname
//   if (currentPath !== '/auth/sign-in' && currentPath !== '/auth/callback') {
//     localStorage.setItem('auth_redirect_url', currentPath)
//   }
// }
//
// /**
//  * 处理Google登录按钮点击
//  * 保存重定向URL并跳转到Google OAuth流程
//  */
// function handleGoogleLogin() {
//   saveRedirectUrl()
//   window.location.href = GOOGLE_AUTH_URL
// }
</script>

<template>
  <div />
  <!--  <UiButton variant="outline" class="w-full" @click="handleGoogleLogin"> -->
  <!--    <Icon icon="simple-icons:google" class="size-5 mr-2" /> -->
  <!--    Google -->
  <!--  </UiButton> -->
</template>

<style scoped></style>
